import useAppStore from "@/context/store";
import getNextDetailsSetp from "@/utils/getHistorySetp";
import { BackTop, Modal } from "antd";
import classNames from "classnames";
import { useRouter } from "next/router";
import { useEffect, useRef } from "react";
import HBIcon from "../HBIcon";
import PinDetail from "./index";
import styles from "./index.module.less";
function PinDetailModal() {
  const router = useRouter();
  const currentPin = useAppStore((s) => s.currentPin);
  // 用来判断是否需要执行拦截操作
  const needInterceptRef = useRef(null);
  useEffect(() => {
    if (currentPin) {
      needInterceptRef.current = true;
    }
  }, [currentPin]);
  const onClose = () => {
    useAppStore.setState({ currentPin: null });
    // window.history.replaceState(null, null, router.asPath);
    // 回退对应的步骤
    let detailsSetp = getNextDetailsSetp();
    history.go(-1 * detailsSetp);
  };
  useEffect(() => {
    /**
     * 这是为了解决页面如果有服务端渲染的方法，
     * 打开详情弹窗，再通过histor.back()这种方法返回的时候，会记录不了前置的滚动位置的问题
     */
    router.beforePopState(({ as, options }) => {
      if (needInterceptRef?.current && !/^\/pins\/\d*$/.test(as)) {
        needInterceptRef.current = false;
        // shallow为true则不执行服务端渲染的方法
        options.shallow = true;
        router.push(as, undefined, options);
        // 阻止路由更改
        return false;
      } else {
        return true;
      }
    });
  }, [router]);
  useEffect(() => {
    const modalWrapper = document.querySelector(".pinDetailModal");
    if (modalWrapper) {
      modalWrapper.scrollTop = 0;
    }
  }, [currentPin]);
  return (
    <Modal
      maskStyle={{
        backgroundColor: "rgba(247, 249, 250, 0.98)",
      }}
      visible={!!currentPin}
      wrapClassName={classNames([styles.modal, "pinDetailModal"])}
      style={{ top: 0 }}
      width="100%"
      footer={null}
      closable={false}
      destroyOnClose
      keyboard={false}
      transitionName=""
      maskTransitionName=""
    >
      <PinDetail
        pinId={currentPin?.pinId}
        file={currentPin?.file}
        currentSrc={currentPin?.currentSrc}
        isModal={true}
        onClose={onClose}
      />

      {/* 返回顶部 */}
      <BackTop
        className={classNames([styles.back, styles.item])}
        target={() => {
          return document.querySelector(".pinDetailModal");
        }}
      >
        <div className={styles.button}>
          <HBIcon className={styles.icon} type="ic_arrow_upward" />
        </div>
      </BackTop>
    </Modal>
  );
}

export default PinDetailModal;
